import React from 'react';
import { Modal } from '@hpstellar/core';
import { Reviews, ButtonIcon, Link } from '@hpstellar/core/visId';
import { X } from '@hpstellar/vis-icons';

import getProductProps from '../../../../get-product-props';
import useAsyncProductData from '../../../../../hooks/useAsyncProductData';
import { withError } from '../../../../../shared/components/error-boundary';

import { ProductTitle } from '../product-details';
import { ProductStockIndicator } from '../product-details/product-labels';
import { PriceContainer, RewardBadgeContainer } from '../product-footer';
import Compare from '../product-footer/compare';
import CTARow from '../product-footer/cta-row';
import ImageGallery from './image-gallery';
import FooterSection from './footer-section';
import SpecsList from './specs-list';
import { formatSpecs } from './util';

export default withError(
    ({
        product,
        images,
        isMobile,
        visible,
        setVisible,
        analyticsData,
        options,
        translations = { offersLinkText: 'See all promo offers', specsLinkText: 'See all specs' },
    }) => {
        const { specs, loading } = useAsyncProductData(product);
        const sourceProduct = product;
        const productProps = getProductProps(sourceProduct, null, {}, {}, {}, {});
        const { ratings, productLinkProps } = productProps || {};
        const { score = 0, reviewsCount = 0, link } = ratings || {};

        const formattedSpecs = formatSpecs(specs);

        function closeModal() {
            setVisible(false);
        }
        const [expanded, setExpanded] = React.useState(true);

        return (
            <Modal
                className="quickViewModal"
                isOpen={visible}
                animationType="fade-in"
                aria-describedby="modal-description"
                aria-labelledby="modal-title"
                horizontalAlignment="center"
                verticalAlignment="center"
                withBackdrop
                backdropClassName="quickViewBackdrop"
            >
                <div className="modalContent">
                    <div className="modalHeader">
                        <ButtonIcon className="offers-close" onClick={closeModal} icon={<X size="s" />} size="medium" />
                    </div>
                    <div class="container">
                        <div class="leftColumn">
                            <ImageGallery images={images} variation={product.variation} />
                        </div>
                        <div class="rightColumn">
                            <ProductStockIndicator product={product} className="stock-indicator" />
                            <Reviews
                                score={score.toFixed(1)}
                                reviewsCount={reviewsCount}
                                GlobalLinkProps={{ to: link }}
                                className="product-rating"
                            />
                            <ProductTitle product={product} productLinkProps={productLinkProps} />
                            <Link to={`${productLinkProps.to}#specialOffers`} className="promoOffers">
                                {translations.offersLinkText}
                            </Link>
                            <PriceContainer product={product} isMobile={isMobile} />
                            <RewardBadgeContainer product={product} />
                            <SpecsList specs={formattedSpecs} limit={2} loading={loading}>
                                {formattedSpecs && formattedSpecs.length > 0 && (
                                    <Link className="allSpecs" onClick={() => setExpanded(!expanded)} theme="dark">
                                        {translations.specsLinkText}
                                    </Link>
                                )}
                            </SpecsList>
                            <Compare product={product} />
                            <CTARow
                                product={product}
                                productLinkProps={productLinkProps}
                                analyticsData={analyticsData}
                                options={options}
                                isMobile={isMobile}
                            />
                        </div>
                    </div>
                    <FooterSection expanded={expanded} setExpanded={setExpanded} specs={formattedSpecs} />
                </div>
            </Modal>
        );
    },
);
